(function (algolia) {
  'use strict';

  algolia.translations = {
    noCollectionFound: "No collection found",
    noPageFound: "No page found",
    collectionsHeader: "Collections",
    articlesHeader: "Translation missing: en.search.articlesHeader",
    zenHeader: "Support Articles",
    pagesHeader: "Pages",
    allProducts: "See all products",
    matching: "matching",
    sortBy: "Sort by",
    relevance: "Relevance",
    outOf: "out of",
    for: "for",
    resultsFound: "results found",
    oneResultFound: "1 result found",
    noResultFound: "No result found",
    noResultFor: "No result for query",
    noResultHelp: "Try changing your search",
    addToCart: "View Product",
    preorder: "Pre-Order",
    soldOut: "Sold Out",
    buyNow: "Buy Now",
    searchForProduct: "Translation missing: en.search.search_for_products",
    selectedFilter: "Selected filters",
    clearAll: "Clear all",
    showFilters: "Show filters",
    hideFilters: "Hide filters",
    showMoreResults: "Load more results"
  };

  algolia.translation_helpers = {
    no_result_for: function (text, render) {
      return algolia.translations.noResultFor + ' ' + render(text) + '';
    },
    out_of: function (text, render) {
      return '' + render(text) + ' ' + algolia.translations.outOf;
    }
  };

}(algoliaShopify));
